import { useEventCallback } from '@cian/react-utils';

import { type FC } from 'react';

import { useReduxState } from '@/app/shared/context/ReduxStoreContext';

import { selectGeo } from '@/packages/JsonQuery/selectGeo';
import { setBbox } from '@/packages/JsonQuery/setBbox';
import { type IJsonQueryPolygon, type TCoordinate } from '@/packages/api-models/common/json_query';
import { boundActionsFactory } from '@/packages/redux-state/store';
import { filtersSelector, usePolygonsSelector } from '@/packages/redux-state/store/slices/jsonQuery';
import { useMapConfigurationDrawModeSelector } from '@/packages/redux-state/store/slices/mapConfiguration';

import { MapPolygons } from './MapPolygons';

const useBoundActions = boundActionsFactory(reduxActions => ({
  setFilters: reduxActions.jsonQuery.setFilters,
}));

export const MapPolygonsContainer: FC = () => {
  const isDrawingMode = useMapConfigurationDrawModeSelector();
  const polygons = usePolygonsSelector();
  const reduxState = useReduxState();
  const actions = useBoundActions();

  const handleAddPolygon = useEventCallback((polygon: IJsonQueryPolygon) => {
    const coordinates: TCoordinate[] = polygon.coordinates.map(([a, b]) => [
      parseFloat(Number(b).toFixed(7)).toString(),
      parseFloat(Number(a).toFixed(7)).toString(),
    ]);

    coordinates.push(coordinates[0]);

    const filters = filtersSelector(reduxState.getState());

    let nextFilters;

    nextFilters = selectGeo(filters)({ ...polygon, coordinates });
    nextFilters = setBbox(nextFilters)(null);

    actions.setFilters(nextFilters);
  });

  return <MapPolygons isDrawingMode={isDrawingMode} polygons={polygons} onAddPolygon={handleAddPolygon} />;
};
